import React from 'react';
import { AccordionItem } from '../ui/Accordion';
export function FAQSection() {
  return <section className="py-16 md:py-24 bg-slate-900 px-4" data-id="element-85">
      <div className="max-w-3xl mx-auto" data-id="element-86">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-87">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2" data-id="element-88">
          <AccordionItem title="¿Necesito experiencia previa?" data-id="element-89">
            No. El curso está pensado para empezar desde cero. Te explicamos
            paso a paso cómo usar las herramientas y desarrollar el criterio de
            un editor profesional.
          </AccordionItem>

          <AccordionItem title="¿Cuándo accedo al contenido?" data-id="element-90">
            Inmediatamente después del pago. El sistema te enviará
            automáticamente un correo con tus datos de acceso a la plataforma
            para que empieces hoy mismo.
          </AccordionItem>

          <AccordionItem title="¿Sirve si quiero trabajar editando?" data-id="element-91">
            Sí. El contenido es claro y completo para empezar a generar
            ingresos. De hecho, tenemos un módulo entero dedicado a cómo
            conseguir clientes y cobrar por tu trabajo.
          </AccordionItem>

          <AccordionItem title="¿Cómo accedo al curso?" data-id="element-92">
            Te llega un mail con el acceso apenas comprás. Podrás entrar desde
            tu computadora, tablet o celular en cualquier momento.
          </AccordionItem>

          <AccordionItem title="¿Tiene garantía?" data-id="element-93">
            Sí, 7 días de garantía total. Si entras, ves el contenido y sientes
            que no es para ti, puedes pedir el reembolso completo con un solo
            clic, sin preguntas.
          </AccordionItem>
        </div>

        <div className="mt-16 text-center bg-slate-800/50 p-8 rounded-3xl border border-slate-700" data-id="element-94">
          <h3 className="text-2xl font-bold text-white mb-6" data-id="element-95">
            ¿Tenés más preguntas? Hablame por WhatsApp
          </h3>
          <a href="https://api.whatsapp.com/send?phone=5493364512841&text=Hola%20quiero%20informacion%20sobre%20el%20curso%20de%20CapCut" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-[#25D366] text-white font-bold px-8 py-4 rounded-xl hover:bg-[#128C7E] transition-colors shadow-lg shadow-[#25D366]/30 hover:shadow-[#25D366]/50" data-id="element-96">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-97">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-98" />
            </svg>
            Hablá Por WhatsApp
          </a>
        </div>
      </div>
    </section>;
}